import axiosClient from './axiosClient'
import { clone } from 'lodash'
const TvanHandleApi = {
  getListInvoice: (params) => {
    const url = '/tvanHandle/listInvoices'
    return axiosClient.get(url, { params })
  },

  moveToSendError: (params) => {
    const url = '/tvanHandle/moveToSendError'
    return axiosClient.post(url, params)
  },

  updateMessage: (params) => {
    const url = '/tvanHandle/updateMessage'
    return axiosClient.post(url, params)
  },

  tvanCheckMessages: (params) => {
    const url = '/tvanHandle/checkMessages'
    return axiosClient.post(url, { params })
  },
  getListCompany: (params) => {
    const url = '/tvanHandle/listAllCompanySuperAdmin'
    return axiosClient.get(url, { params })
  },
  updateConfigCompany: async (body) => {
    const url = `/tvanHandle/updateConfigCompany`
    return axiosClient.post(url, body)
  },
  getAccountingDocuments: async (body) => {
    const url = '/tvanHandle/findAccountingDocuments'
    return axiosClient.post(url, body)
  },
  copyAccountingDocuments: async (body) => {
    const url = '/tvanHandle/copyAds'
    return axiosClient.post(url, body)
  },
  getRegistrationsAdmin: (params, signal) => {
    const clonedParams = clone(params)
    clonedParams.page =
      clonedParams.page === 0 ? clonedParams.page : clonedParams.page - 1
    const url = '/tvanHandle/registration'

    return axiosClient.get(url, { params: clonedParams, signal })
  },
}

export default TvanHandleApi
